// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReportingController = function ($rootScope, $scope, $http, $location, $filter, gettext, CustomFieldSettings, DatepickerUtils) {
    $scope.reports = [
        new Report("ActiveProducts", gettext("Active Products"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("PaymentOverview", gettext("Payment Overview"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("PaymentOverviewExtended", gettext("Payment Overview (Extended)"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("DebtorBalance", gettext("Debtor Balances"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("OpenItems", gettext("Open Items"), {
            roles: ['Reports', 'Finance'],
            showToDate: true
        }),
        new Report("OpenItemsDebtCollection", gettext("Open Items in Debt Collection"), {
            roles: ['Reports', 'Finance'],
            feature: "InDevelopment_DebtCollection",
            showToDate: true
        }),
        new Report("DunningOverview", gettext("Dunning overview"), {
            roles: ['Reports', 'Finance']
        }),
        new Report("Turnover", gettext("Turnover"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("TurnoverForecast", gettext("Turnover Forecast"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("Contracts", gettext("Contracts"), {
            roles: ['Reports']
        }),
        new Report("ComponentSubscriptions", gettext("Component Subscriptions"), {
            roles: ['Reports'],
            showCustomExportPeriod: true,
            isDateOptional: true
        }),
        new Report("DiscountSubscriptions", gettext("Discount Subscriptions"), {
            roles: ['Reports']
        }),
        new Report("AggregateAccounting", gettext("Aggregate Accounting"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("DeferredInvoices", gettext("Deferred Invoices"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("TrustedShopsTurnover", gettext("Trusted Shops Turnover Report"), {
            roles: ['Reports', 'Finance'],
            feature: "trusted_shops",
            showCustomExportPeriod: true
        }),
        new Report("AmazonIapReceipts", gettext("Amazon IAP Receipts"), {
            roles: ['Reports'],
            feature: "amazon_iap"
        }),
        new Report("AppleIapReceipts", gettext("Apple IAP Receipts"), {
            roles: ['Reports'],
            feature: "apple_iap"
        }),
        new Report("GoogleIapReceipts", gettext("Google IAP Receipts"), {
            roles: ['Reports'],
            feature: "GoogleIap"
        }),
        new Report("ExaringAccountingPdf", gettext("Exaring accounting PDF"), {
            roles: ['Reports', 'Finance'],
            feature: "exaring",
            showFormat: false,
            showCustomExportPeriod: true,
        }),
        new Report("ExaringIfrs15Pdf", gettext("Exaring IFRS15 PDF"), {
            roles: ['Reports', 'Finance'],
            feature: "exaring",
            showFormat: false,
            showExportPeriod: true,
            showCustomExportPeriod: false,
            hideDefaultOptionInExportPeriod: false
        }),
        new Report("ExaringIfrs15Csv", gettext("Exaring IFRS15"), {
            roles: ['Reports', 'Finance'],
            feature: "exaring",
            showFormat: true,
            showExportPeriod: true,
            showCustomExportPeriod: false,
            hideDefaultOptionInExportPeriod: false
        }),
        new Report("HaufelexwareAccountingPdf", gettext("Haufe Lexware accounting PDF"), {
            roles: ['Reports', 'Finance'],
            feature: "haufelexware",
            showFormat: false,
            showCustomExportPeriod: true
        }),
        new Report("AggregateContractPhaseChange", gettext("Aggregate Contract Phase Change"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("ContractPhaseChange", gettext("Contract Phase Change"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("ContractPhaseChangeLexware", gettext("Contract Phase Change Lexware"), {
            roles: ['Reports'],
            feature: "haufelexware",
            showCustomExportPeriod: true
        }),
        new Report("Ageing", gettext("Accounts Receivables Ageing Report"), {
            roles: ['Reports', 'Finance'],
            showToDate: true
        }),
        new Report("ContractChurn", gettext("Contract Churn Overview"), {
            roles: ['Reports'],
            showCustomExportPeriod: true
        }),
        new Report("MossExtended", gettext("MOSS (Extended)"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("OssElster", gettext("OSS (Elster)"), {
            roles: ['Reports', 'Finance'],
            showFormat: false,
            showQuarterExportPeriod: true
        }),
        new Report("RtlFastStats", gettext("RTL Fast Stats"), {
            roles: ['Reports'],
            feature: "Rtl",
            showFormat: false,
            showExportPeriod: false
        }),
        new Report("RtlManualUserActions", gettext("RTL Manual User Actions"), {
            roles: ['Admin'],
            feature: "Rtl",
            showFormat: false,
            showExportPeriod: true,
            showCustomExportPeriod: false,
            hideDefaultOptionInExportPeriod: true,
        }),
        new Report("ContractNetTurnover", gettext("Contract Net Turnover"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("Orders", gettext("Orders"), {
            roles: ['Reports', 'Finance'],
            showCustomExportPeriod: true
        }),
        new Report("PayOneReconByMonth", gettext("PayOne billwerk Reconciliation Report by month"), {
            roles: ['Reports', 'Admin'],
            feature: "PayOneReconciliation",
            showExportPeriod: true
        }),
        new Report("PayOneReconByFile", gettext("PayOne billwerk Reconciliation Report by billing document"), {
            roles: ['Reports', 'Admin'],
            feature: "PayOneReconciliation",
            showFileOptions: true
        }),
        new Report("ProductMonthsBilled", gettext("Product months billed"), {
            roles: ['Reports', 'Admin'],
            feature: "Rtl",
            showCustomExportPeriod: true
        }),
        new Report("ProductMonthsBilledWithOpenItems", gettext("Product months billed with open items"), {
            roles: ['Reports', 'Admin'],
            feature: "Rtl",
            showCustomExportPeriod: true
        }),
        new Report("ProductMonthsBilledByFeePeriod", gettext("Product months billed by fee period"), {
            roles: ['Reports', 'Admin'],
            feature: "Rtl",
            showCustomExportPeriod: true
        }),
        new Report("AssignmentOverview", gettext("Assignment Overview"), {
            roles: ['Reports', 'Admin'],
            feature: "Rtl"
        }),
        new Report("Cancellations", gettext("Cancellations"), {
            roles: ['Reports', 'Admin']
        }),
        new Report("LineItems", gettext("Line Items"), {
            roles: ['Reports', 'Finance', 'Admin'],
            showCustomExportPeriod: true
        }),
        new Report("LineItemsInInterval", gettext("Line Items in Interval"), {
            roles: ['Reports', 'Finance', 'Admin'],
            feature: "Rtl",
            showCustomExportPeriod: true
        }),
        new Report("Invoices", gettext("Invoices"), {
            roles: ['Reports', 'Finance', 'Admin'],
            showCustomExportPeriod: true
        }),        
        new Report("EweInvoices", gettext("Ewe Invoices"), {
            roles: ['Reports', 'Finance', 'Admin'],
            feature: "Ewe",
            showCustomExportPeriod: true
        }),
        new Report("ContractPauses", gettext("Contract Pauses"), {
            roles: ['Reports', 'Finance', 'Admin']
        }),
        new Report("MonthlyRecurringRevenue", gettext("Monthly Recurring Revenue"), {
            roles: ['Reports', 'Finance', 'Admin'],
            showCustomExportPeriod: true
        }), 
    ];

    $scope.referenceDate = null;

    function Report(id, name, options) {
        function orDefault(value, defaultValue) {
            return value !== undefined ? value : defaultValue;
        }

        options = options || {};

        this.id = id;
        this.name = name;
        this.roles = options.roles;
        this.feature = options.feature;
        this.showFormat = orDefault(options.showFormat, true);
        this.showExportPeriod = orDefault(options.showExportPeriod, false);
        this.showToDate = orDefault(options.showToDate, false);
        this.showCustomExportPeriod = orDefault(options.showCustomExportPeriod, false);
        this.showQuarterExportPeriod = orDefault(options.showQuarterExportPeriod, false);
        this.showFileOptions = orDefault(options.showFileOptions, false);
        this.hideDefaultOptionInExportPeriod = orDefault(options.hideDefaultOptionInExportPeriod, false);
        this.isDateOptional = orDefault(options.isDateOptional, false);

        // translate name property in permitted reports object array
        // to be able to sort on the view page
        this.translatedName = $filter('translate')(name);
    }
    
    function getReferenceDate() {
        let referenceDate = new Date();
        if ($scope.referenceDate)
            referenceDate = DatepickerUtils.backToBrowserTimezone($scope.referenceDate);

        referenceDate.setDate(referenceDate.getDate() + 1);
        return {
            "DateRange": {
                "Start": '' + referenceDate.getFullYear() + '-' + (referenceDate.getMonth() + 1).toString().padStart(2, '0') + '-' + referenceDate.getDate().toString().padStart(2, '0'),
                "ExclusiveEnd": '' + referenceDate.getFullYear() + '-' + (referenceDate.getMonth() + 1).toString().padStart(2, '0') + '-' + referenceDate.getDate().toString().padStart(2, '0')
            }
        };
    }

    function getIntervalDates() {
        var dFrom = new Date();
        if ($scope.dateRange.dateFrom)
            dFrom.setTime(Date.parse($scope.dateRange.dateFrom));

        var dTo = new Date();
        if ($scope.dateRange.dateTo)
            dTo.setTime(Date.parse($scope.dateRange.dateTo));
        dTo.setDate(dTo.getDate() + 1);

        return {
            "DateRange": {
                "Start": '' + dFrom.getFullYear() + '-' + (dFrom.getMonth() + 1).toString().padStart(2, '0') + '-' + dFrom.getDate().toString().padStart(2, '0'),
                "ExclusiveEnd": '' + dTo.getFullYear() + '-' + (dTo.getMonth() + 1).toString().padStart(2, '0') + '-' + dTo.getDate().toString().padStart(2, '0')
            }
        };
    }

    function getSelectedQuarterDates() {
        const monthsInQuarter = 3;
        const firstDateInMonth = 1;
        
        const quarterStart = new Date($scope.selectedQuarter.year, monthsInQuarter * ($scope.selectedQuarter.quarterNumber - 1) + 1, firstDateInMonth);
        const quarterEnd = new Date($scope.selectedQuarter.year, quarterStart.getMonth() + monthsInQuarter, firstDateInMonth);

        return {
            "DateRange": {
                "Start": '' + quarterStart.getFullYear() + '-' + quarterStart.getMonth().toString().padStart(2, '0') + '-' + quarterStart.getDate().toString().padStart(2, '0'),
                "ExclusiveEnd": '' + quarterEnd.getFullYear() + '-' + quarterEnd.getMonth().toString().padStart(2, '0') + '-' + quarterEnd.getDate().toString().padStart(2, '0')
            }
        };
    }
    
    function getParameters() {
        if ($scope.selectedReport.showToDate) {
            return getReferenceDate();
        }
        if ($scope.selectedReport.showQuarterExportPeriod) {
            return getSelectedQuarterDates();
        }
        if ($scope.ExportBy === 'Custom') {
            return getIntervalDates();
        }
        if (shouldClearDateParameters()) {
            return {};
        }

        var isMonthSelected = $scope.parameters.Month !== '' && $scope.parameters.Month !== null && $scope.parameters.Month !== undefined;
        var startDateStr = '' + $scope.parameters.Year + '-' + (isMonthSelected ? $scope.parameters.Month : 1).toString().padStart(2, '0') + '-01';
        var date = new Date(startDateStr);
        if (isMonthSelected)
            date.setMonth(date.getMonth() + 1)
        else
            date.setFullYear(date.getFullYear() + 1);

        return {
            "DateRange": {
                "Start": startDateStr,
                "ExclusiveEnd": '' + date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-01'
            }
        };
    }
    
    $scope.validateParametersBeforeExport = function(){
        switch ($scope.selectedReport.id) {
            case "RtlManualUserActions":
                return ($scope.parameters.Month !== '' && $scope.parameters.Month !== null && $scope.parameters.Month !== undefined);
            default:
                return true;
        }
    }

    $scope.getQuarterDisplayName = function(quarter) {
        var quarterDisplayName;

        switch (quarter.quarterNumber) {
            case 1:
                quarterDisplayName = gettext('Q1 (Jan-Mar)');
                break;
            case 2:
                quarterDisplayName = gettext('Q2 (Apr-Jun)');
                break;
            case 3:
                quarterDisplayName = gettext('Q3 (Jul-Sep)');
                break;
            case 4:
                quarterDisplayName = gettext('Q4 (Oct-Dec)');
                break;
        }

        return `${quarter.year}-${quarterDisplayName}`;
    }

    $scope.shouldShow = function (report) {
        var result = $rootScope.adminOrInRole(report.roles);
        if (report.feature !== undefined)
            result = result && $rootScope.features[report.feature];
        return result;
    };

    $scope.isValidData = function () {
        if ($scope.selectedReport.isDateOptional && $scope.ExportBy === 'AllTime') {
            return true;
        }
        if ($scope.ExportBy === 'Custom') {
            return ($scope.dateRange.dateFrom && $scope.dateRange.dateTo);
        }
        return $scope.parameters.Year > 0;
    };

    var getGroupByForContractNetTurnoverReport = function () {
        $scope.groupBy = [];
        $scope.groupBy.push({ Key: null, DisplayName: gettext("None") });
        $scope.currentGroupBy = $scope.groupBy[0];

        CustomFieldSettings
            .get({ customFieldType: customSettingsType },
                function (data) {
                    let descriptors = data.CustomFieldDescriptors;

                    for (var i = 0; i < descriptors.length; i++) {
                        let item = descriptors[i];
                        $scope.groupBy.push({ Key: item.Key, DisplayName: item.DisplayName._c });
                    }
                });
    };
    var getReconciliationReports = function () {
        $http({
            method: "GET",
            url: "/api/v1/reports/reconciliationReports",
            cache: false
        }).then(function (response) {
            $scope.reconciliationReports = response.data;
            $scope.parameters.pspReport = $scope.reconciliationReports[0];
        });
    };
    
    $scope.$watch('selectedReport', function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
            if ($scope.selectedReport.id === reportTypeContractNetTurnover) {
                getGroupByForContractNetTurnoverReport();
            }

            if ($scope.selectedReport && $scope.selectedReport.id === reportTypePayOneReconByFile) {
                getReconciliationReports();
            }

            if ($scope.selectedReport && $scope.selectedReport.isDateOptional) {
                $scope.ExportBy = 'AllTime';
            }
        }
    });

    $scope.setExportByAllTime = function () {
        if ($scope.selectedReport && $scope.selectedReport.isDateOptional) {
            $scope.ExportBy = 'AllTime';
            $scope.parameters.Year = null;
            $scope.parameters.Month = null;
            if ($scope.dateRange) {
                $scope.dateRange.dateFrom = null;
                $scope.dateRange.dateTo = null;
            }
        }
    };
 
    var clearExport = function () {
        $scope.result = null;
    };

    $scope.export = function () {
        clearExport();
        var parameters = getParameters();
        parameters.Locale = $scope.parameters.Locale;
        parameters.Format = $scope.parameters.Format;
        parameters.SendEmailAfterFinish = $scope.parameters.SendEmailAfterFinish;
        if ($scope.selectedReport.id === reportTypeContractNetTurnover) {
            parameters.GroupBy = $scope.parameters.GroupBy;
        }
        if ($scope.selectedReport.id === reportTypePayOneReconByFile) {
            parameters.PSPReportId = $scope.parameters.pspReport.Id;
        }

        $http({
            method: "POST",
            url: "/api/v1/reports/" + $scope.selectedReport.id,
            params: {},
            data: parameters,
            headers: {},
            cache: false
        }).then(function (response) {
            $scope.result = response.data;
            $location.path("/activities/reporting-files");
        });
    };

    $scope.changedGroupBy = function () {
        $scope.parameters.GroupBy = $scope.currentGroupBy.Key;
    };
    
    $scope.getPreviousQuarter = function (year, quarterNumber) {
        const firstQuarterNumber = 1;
        
        if (quarterNumber === firstQuarterNumber) {
            const lastQuarterNumber = 4;
            return { year: year - 1, quarterNumber: lastQuarterNumber};
        }
        return { year: year, quarterNumber: quarterNumber - 1};
    }
    
    $scope.getPreviousQuarterForCurrentMoment = function () {
        const monthsPerQuarter = 3;
        let currentQuarterNumber = Math.floor(moment().month() / monthsPerQuarter) + 1;

        return $scope.getPreviousQuarter(moment().year(), currentQuarterNumber);
    }

    $scope.selectedReport = $scope.reports[0];

    const customSettingsType = 'Product';
    const reportTypeContractNetTurnover = 'ContractNetTurnover';
    const reportTypePayOneReconByFile = 'PayOneReconByFile';

    function shouldClearDateParameters() {
        return !$scope.selectedReport.showCustomExportPeriod ||
            ($scope.selectedReport.isDateOptional && $scope.ExportBy === 'AllTime');
    }

    $scope.changed = function () {
        $scope.parameters.Locale = $scope.formatChoice.Locale;
        $scope.parameters.Format = $scope.formatChoice.Format;
        clearExport();
    };

    $scope.formatChoices = [
        { Name: "CSV German", Format: "Csv", Locale: "de-DE" },
        { Name: "CSV English", Format: "Csv", Locale: "en-US" },
        { Name: "JSON", Format: "Json", Locale: null },
        { Name: "JSON-Lines", Format: "JsonLines", Locale: null },
    ];
    
    $scope.formatChoice = $scope.formatChoices[0];
    $scope.years = [];
    
    for (var year = moment().year() + 1; year >= 2013; year--) {
        $scope.years.push(year);
    }
    
    $scope.months = [
        { label: "January", value: 1 },
        { label: "February", value: 2 },
        { label: "March", value: 3 },
        { label: "April", value: 4 },
        { label: "May", value: 5 },
        { label: "June", value: 6 },
        { label: "July", value: 7 },
        { label: "August", value: 8 },
        { label: "September", value: 9 },
        { label: "October", value: 10 },
        { label: "November", value: 11 },
        { label: "December", value: 12 },
    ];

    const lastNotDisplayedQuarter = { year: 2021, quarterNumber: 2};
    $scope.quarters = [];


    for (let quarter = $scope.getPreviousQuarterForCurrentMoment();
         quarter.year !== lastNotDisplayedQuarter.year || quarter.quarterNumber !== lastNotDisplayedQuarter.quarterNumber;
         quarter = $scope.getPreviousQuarter(quarter.year, quarter.quarterNumber))
    {
        $scope.quarters.push({year: quarter.year, quarterNumber: quarter.quarterNumber});
    }

    $scope.selectedQuarter = $scope.quarters[0];
    $scope.parameters = { Year: moment().year() };
    $scope.changed();

    if ($location.absUrl().includes("activities/reporting")) {
        const analyticData = {
            url: $location.absUrl(),
            path: "activities/reporting",
            userAgent: window.navigator.userAgent
        };
    }
};
ReportingController.$inject = ['$rootScope', '$scope', '$http', '$location', '$filter', 'gettext', 'CustomFieldSettings', 
    'DatepickerUtils'];

var ReportingFilesController = function ($scope, $http, $window, $routeParams, Report, gettext, ReportDownloadService) {
    $scope.parameters = { Year: moment().year(), Locale: "de-DE" };
    $scope.showGoBackAlert = $routeParams.redirected || false;

    var source = Rx.Observable
        .interval(10000)
        .timeInterval();

    function update() {
        $scope.reports = $scope.paginator(Report.query, { isExtended : true}, 20);
    }

    var subscription = source.subscribe(
        function (x) {
            if ($scope.reports.pageIndex === 1)
                update();
        });

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Finished':
                return "label-success";
            case 'InProgress':
                return "label-warning";
            case 'Failed':
                return "label-important";
            default:
                return '';
        }
    };

    $scope.download = function (reportId) {
        ReportDownloadService.downloadReport(reportId, $scope.parameters,
            function (response) {
                var downloadInfo = response.data;
                $scope.downloadFile(downloadInfo.Url);
            }, function (error) {
                $scope.reports = Report.query();
            });
    };

    $scope.goBack = function () {
        $window.history.back();
    }

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
    });
    gettext("Finished");
    gettext("InProgress");
    gettext("Queued");
    update();
};
ReportingFilesController.$inject = ['$scope', '$http', '$window', '$routeParams', 'Report', 'gettext', 'ReportDownloadService'];
